import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { FilterSearch } from "../../../../../shared/components/createOrder/components/FilterSearch"

const useStyles = makeStyles()((theme) => ({
    searchContainer: {
        position: "sticky",
        top: 0,
        zIndex: 2,
        padding: ".75rem",
        backgroundColor: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.tailwind.slate[200]}`,
    },
    searchField: {
        "&& .MuiOutlinedInput-root": {
            height: "2.75rem",
            backgroundColor: theme.palette.tailwind.slate[50],
            boxShadow: "none",
        },
    },
}))

type SearchOrdersInPopupProps = Readonly<{
    searchQuery: string
    setSearchQuery: (query: string) => void
}>

export function SearchOrdersInPopup({ searchQuery, setSearchQuery }: SearchOrdersInPopupProps) {
    const { classes } = useStyles()

    return (
        <Box
            className={classes.searchContainer}
            onKeyDown={(event) => event.key !== "Escape" && event.stopPropagation()}
        >
            <FilterSearch
                search={searchQuery}
                setSearch={setSearchQuery}
                defaultActive
                activeWidth="100%"
                debounceMs={0}
                className={classes.searchField}
                placeholderId="merchant-receipt-dropdown-search-label"
            />
        </Box>
    )
}
